import breakpoints from '../utils/rbata.breakpoints';

const parallax = {
    selector:         '.parallax',
    $window:          undefined,
    $parallaxElement: undefined,
    unit:             {
        pixels:         'px',
        verticalHeight: 'vh',
        percent:        '%'
    },

    config: {
        max:        -80,
        min:        0,
        res:        'any',
        unit:       'px',
        startPoint: 0.5,
        hardness:   0.15
    },

    breakpoints: {
        mob:  'mobile',
        tab:  'tablet',
        desk: 'desktop',
        any:  'any'
    },

    init() {
        this.$body = document.querySelector('body');
        this.$parallaxElement = document.querySelectorAll(this.selector);
        this.bindParallax();
        this.handleViewportChange();
    },

    smoothReposition(elem, elemData) {
        if (!elemData.parallaxLoaded) {
            elem.style.transition = 'all ease 0.25s';
            setTimeout(() => {
                elem.style.transition = '';
            }, 250);

            elem.dataset.parallaxLoaded = true;
        }
    },

    bindParallax() {
        window.onload = parallax.onScrollAndLoad;
        window.onscroll = parallax.onScrollAndLoad;
    },

    onScrollAndLoad() {
        parallax.$parallaxElement.forEach((element, index) => {
            parallax.smoothReposition(element, element.dataset);
            const elemData = element.dataset.parallax ? JSON.parse(element.dataset.parallax) : parallax.config,
                    windowTopOffset = window.scrollY,
                    elementTop = element.getBoundingClientRect().top + window.scrollY,
                    elementHeight = element.offsetHeight,
                    viewPortHeight = window.innerHeight * elemData.startPoint - elementHeight * elemData.startPoint,
                    scrolled = windowTopOffset - elementTop + viewPortHeight;
            parallax.transform(element, elemData, scrolled);
        });
    },

    calculateMinMax(elemData, scrolled) {

        if (breakpoints.manualBreakpoints(window.innerWidth) === parallax.breakpoints[elemData.res]) {
            return this.getFactor(elemData, scrolled);
        }

        //fallback
        if (elemData.res === parallax.breakpoints.any) {
            return this.getFactor(elemData, scrolled);
        }

        return 0;
    },

    getFactor(elemData, scrolled) {
        const factor = scrolled * elemData.hardness;
        switch (elemData.unit) {
            case parallax.unit.verticalHeight:
                if (factor >= parallax.vhToPx(elemData.min)) {
                    return parallax.vhToPx(elemData.min);
                }
                if (factor <= parallax.vhToPx(elemData.max)) {
                    return parallax.vhToPx(elemData.max);
                }
                return factor;

            case parallax.unit.percent:
                if (factor >= parallax.percentToPx(elemData.min)) {
                    return parallax.percentToPx(elemData.min);
                }
                if (factor <= parallax.percentToPx(elemData.max)) {
                    return parallax.percentToPx(elemData.max);
                }
                return factor;
            default:
                if (factor >= elemData.min) {
                    return elemData.min;
                }
                if (factor <= elemData.max) {
                    return elemData.max;
                }
                return factor;
        }
    },

    transform(elem, elemData, scrolled = 0) {
        const scale = !elemData.scale ? 1 : 1.05;
        elem.style.transform = `translate3d(0,${parallax.calculateMinMax(elemData, scrolled)}px, 0) scale(${scale})`;
    },

    vhToPx(value) {
        const size = window.innerHeight ||
                document.documentElement.clientHeight ||
                document.body.clientHeight;

        return (size * value) / 100;
    },

    percentToPx(value) {
        return ((window.screen.height - value) / window.screen.height) * 100 * Math.sign(value);
    },

    reloadParallaxPool() {
        this.$parallaxElement = document.querySelectorAll(this.selector);
    },
    handleViewportChange() {
        $(window).on('resize', this.onScrollAndLoad);
    }
}

parallax.init();

export default parallax;